import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUsers = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 23,
	height: 19,
	viewBox: "0 0 23 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M13.1675 18.0001C13.1675 14.4234 10.5092 11.5239 7.22998 11.5239C3.95079 11.5239 1.29248 14.4234 1.29248 18.0001",
			stroke: "#333333",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.9592 13.523C15.504 13.2782 16.1028 13.1428 16.7313 13.1428C19.2504 13.1428 21.2926 15.3174 21.2926 18",
			stroke: "#333333",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.22998 8.28571C9.19749 8.28571 10.7925 6.65475 10.7925 4.64286C10.7925 2.63096 9.19749 1 7.22998 1C5.26247 1 3.66748 2.63096 3.66748 4.64286C3.66748 6.65475 5.26247 8.28571 7.22998 8.28571Z",
			stroke: "#333333",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M17.1809 10.5836C18.5348 10.5836 19.6325 9.46127 19.6325 8.07674C19.6325 6.69221 18.5348 5.56982 17.1809 5.56982C15.8269 5.56982 14.7292 6.69221 14.7292 8.07674C14.7292 9.46127 15.8269 10.5836 17.1809 10.5836Z",
			stroke: "#333333",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgUsers;
